// extracted by mini-css-extract-plugin
module.exports = {"icon":"SubTitleIcon_icon__8vWqY","light":"SubTitleIcon_light__1snqn"};